export const getGlobalOverviewSelectedCountriesSelector = state => state.globalOverviewSelectedCountries;
export const getTopFiltersRawData = state => state.filtersReducer.topFilters;
export const getFiltersThrownError = state => state.filtersReducer.filtersThrownError?.status;
export const getFiltersDetailedThrownError = state => state.filtersReducer.filtersThrownError;
export const getPageRelatedToFiltersSelector = state => state.filtersReducer.filtersFor;
